import React from 'react';
import { CircularProgress, IconButton, MenuItem, Stack } from '@mui/material';
import { theme } from '../../styles/theme';
import { IIconMenuItemProps } from './types';
import { ArrowIcon } from '../../../../icons/ArrowIcon';

export const IconMenuItem: React.FC<IIconMenuItemProps> = ({
  title,
  children,
  withChevron,
  onClick
}) => {
  const [isLoading, setIsLoading] = React.useState(false);

  const handleClick = () => {
    // a () => void handler may still return e.g. a dispatched plain action
    const result: any = onClick();
    if (typeof result?.then !== 'function') return;
    setIsLoading(true);
    Promise.resolve(result).finally(() => setIsLoading(false));
  };

  return (
    <MenuItem
      disabled={isLoading}
      onClick={handleClick}
      sx={{
        '.MuiStack-root': {
          fontWeight: 500,
        },
      }}
    >
      <Stack
        direction={'row'}
        alignItems={'center'}
        sx={{ width: 1 }}
      >
        {/* no own onClick: the click bubbles to MenuItem, a second handler fired the action twice */}
        <IconButton
          tabIndex={-1}
          color={'primary'}
          sx={{
            width: theme.spacing(5),
            height: theme.spacing(4),
            py: theme.spacing(.5),
            color: theme.palette.grey[400],
          }}
        >
          {isLoading
            ? <CircularProgress size={theme.spacing(2)} />
            : children
          }
        </IconButton>
        {title}
        {!!withChevron &&
          <ArrowIcon
            sx={{
              width: 'min-content',
              height: theme.spacing(1.5),
              ml: 'auto',
              mr: theme.spacing(.5),
              pl: theme.spacing(1),
              color: theme.palette.grey[400],
            }}
          />
        }
      </Stack>
    </MenuItem>
  );
}
